import { FriendshipWithUser } from '../models';
import { FriendshipRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetPendingFriendRequestsUseCase {
  constructor(private friendshipRepository: FriendshipRepository) {}

  async execute(userId: string, limit?: number, offset?: number): Promise<FriendshipWithUser[]> {
    logger.debug('GetPendingFriendRequests', 'Fetching pending requests', { userId });

    const requests = await this.friendshipRepository.getPendingRequests(userId, limit, offset);

    logger.debug('GetPendingFriendRequests', 'Found pending requests', { count: requests.length });

    return requests;
  }
}
